module.exports = __webpack_public_path__ + "static/img/jinritoutiao.9bcadd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/jinritoutiao.png
// module id = 4a/k
// module chunks = 39